module.exports = __webpack_public_path__ + "img/RotateL.fcda46f7.png";